/**
 * Main JavaScript Orchestration for Gina Agency Theme
 */
document.addEventListener('DOMContentLoaded', function() {
  'use strict';

  // Initialize Lucide Icons
  if (typeof lucide !== 'undefined' && typeof lucide.createIcons === 'function') {
    lucide.createIcons();
  }

  // Initialize Header module
  if (window.GinaHeader && typeof window.GinaHeader.init === 'function') {
    window.GinaHeader.init();
  }

  // Initialize Accordion module
  if (window.GinaAccordion && typeof window.GinaAccordion.init === 'function') {
    window.GinaAccordion.init();
  }

  // Initialize Stages interactivity
  if (window.GinaStages && typeof window.GinaStages.init === 'function') {
    window.GinaStages.init();
  }

  // Initialize Performance Dashboard
  if (window.GinaPerformanceDashboard && typeof window.GinaPerformanceDashboard.init === 'function') {
    window.GinaPerformanceDashboard.init();
  }

  // Initialize Scroll Reveal Animations
  if (window.GinaScrollReveal && typeof window.GinaScrollReveal.init === 'function') {
    window.GinaScrollReveal.init();
  }

  // Initialize Three.js Hero Visualizer
  if (window.GinaThreeHero && typeof window.GinaThreeHero.init === 'function') {
    window.GinaThreeHero.init();
  }

  // Initialize Partner Infinite Loop Slider
  if (window.GinaPartnerSlider && typeof window.GinaPartnerSlider.init === 'function') {
    window.GinaPartnerSlider.init();
  }

  // Initialize Contact Module
  if (window.GinaContact && typeof window.GinaContact.init === 'function') {
    window.GinaContact.init();
  }

  // Initialize Recruitment Module
  if (window.GinaRecruitment && typeof window.GinaRecruitment.init === 'function') {
    window.GinaRecruitment.init();
  }

  // Initialize Archive Search Module (Insects & Services)
  if (window.GinaArchiveSearch && typeof window.GinaArchiveSearch.init === 'function') {
    window.GinaArchiveSearch.init();
  }


  // Initialize Scroll to Top Button
  const scrollTopBtn = document.getElementById('scroll-to-top');
  if (scrollTopBtn) {
    function toggleScrollTop() {
      if (window.scrollY > 200) {
        scrollTopBtn.classList.remove('opacity-0', 'translate-y-6', 'pointer-events-none');
        scrollTopBtn.classList.add('is-visible', 'opacity-100', 'translate-y-0', 'pointer-events-auto');
      } else {
        scrollTopBtn.classList.remove('is-visible', 'opacity-100', 'translate-y-0', 'pointer-events-auto');
        scrollTopBtn.classList.add('opacity-0', 'translate-y-6', 'pointer-events-none');
      }
    }

    window.addEventListener('scroll', toggleScrollTop, { passive: true });
    toggleScrollTop();

    scrollTopBtn.addEventListener('click', function(e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
});
